import PropTypes from "prop-types";

export default PropTypes.arrayOf(
  PropTypes.shape({
    label: PropTypes.string,
    className: PropTypes.string,
    notification: PropTypes.bool,
    icons: PropTypes.arrayOf(
      PropTypes.shape({
        name: PropTypes.string,
        className: PropTypes.string,
      })
    ),
    sublinks: PropTypes.arrayOf(
      PropTypes.shape({
        label: PropTypes.string,
        icons: PropTypes.arrayOf(
          PropTypes.shape({
            name: PropTypes.string,
            className: PropTypes.string,
          })
        ),
      })
    ),
  })
);
